import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { CartProvider } from "./context/CartContext";
import Navbar from "./components/Navbar/Navbar";
import CartSidebar from "./components/Cart/CartSidebar";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Contact from "./pages/Contact";
import OrderSuccess from "./pages/OrderSuccess";
import AdminOrders from "./pages/AdminOrders";
import CheckoutForm from "./components/Checkout/CheckoutForm";
import ContentPage from "./pages/ContentPage";
import {
  FAQS_PAGE,
  ORDER_TRACKING_PAGE,
  SHIPPING_POLICY_PAGE,
  REFUND_POLICY_PAGE,
  TERMS_PAGE,
  PRIVACY_PAGE,
} from "./pages/contentPages";

export default function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <CartProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              fontFamily: "Jost, sans-serif",
              fontSize: "13px",
              borderRadius: "2px",
              border: "1px solid #f0f0f0",
            },
            success: {
              iconTheme: { primary: "#C41E2A", secondary: "#fff" },
            },
          }}
        />
        <ScrollToTop />
        <Navbar />
        <CartSidebar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/checkout" element={<CheckoutForm />} />
            <Route path="/order-success" element={<OrderSuccess />} />
            <Route path="/faqs" element={<ContentPage {...FAQS_PAGE} />} />
            <Route path="/order-tracking" element={<ContentPage {...ORDER_TRACKING_PAGE} />} />
            <Route path="/shipping-policy" element={<ContentPage {...SHIPPING_POLICY_PAGE} />} />
            <Route path="/refund-policy" element={<ContentPage {...REFUND_POLICY_PAGE} />} />
            <Route path="/terms" element={<ContentPage {...TERMS_PAGE} />} />
            <Route path="/privacy" element={<ContentPage {...PRIVACY_PAGE} />} />
            <Route path="/ad_min_1" element={<AdminOrders />} />
          </Routes>
        </main>
        <Footer />
      </CartProvider>
    </BrowserRouter>
  );
}
